"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemShowPopup = exports.MenuItemDoClickFunction = exports.MenuItemDoReduxAction = void 0;
const tslib_1 = require("tslib");
const PopupRedux = tslib_1.__importStar(require("../Redux/ActionsReducers/PopupRedux"));
// A menu item which performs a Redux Action when it is clicke
class MenuItemDoReduxAction {
    constructor(label, module, reduxAction, icon, isVisible) {
        this.label = label;
        this.module = module;
        this.isVisible = isVisible;
        this.icon = {
            name: icon,
        };
        this.reduxAction = reduxAction;
    }
}
exports.MenuItemDoReduxAction = MenuItemDoReduxAction;
class MenuItemDoClickFunction {
    constructor(label, module, clickFunction, icon, isVisible) {
        this.label = label;
        this.module = module;
        this.isVisible = isVisible;
        this.icon = {
            name: icon,
        };
        this.onClick = clickFunction;
    }
}
exports.MenuItemDoClickFunction = MenuItemDoClickFunction;
// A menu item which shows a popup screen when it is clieked
class MenuItemShowPopup {
    constructor(label, module, componentName, icon, isVisible, popupParams) {
        this.label = label;
        this.module = module;
        this.isVisible = isVisible;
        this.icon = {
            name: icon,
        };
        this.reduxAction = PopupRedux.PopupShowScreen(module, componentName, popupParams);
    }
}
exports.MenuItemShowPopup = MenuItemShowPopup;
